import React from 'react';
import ExclusiveCourses from './ExclusiveCourses';

const OurCourses = () => {
    return (
        <div className='px-4 md:px-12 pt-2 md:pt-8'>
            <ExclusiveCourses />
        </div>
    );
};

export default OurCourses;